module.exports = __webpack_public_path__ + "static/media/rchic_th.549d1650.png";